import React, { useState, useEffect, useMemo } from 'react';
import MailMenuRender from '../MailMenuRender/MailMenuRender';
import MailListMenuConfig from '../mailMenuConifg/MailListMenuConfig';
import { mergeMenuConfig } from '../util';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
const MailMenuBase = props => {
    const { mail, menu, defaultMenu = MailListMenuConfig, onMenuClick, menuItemStateMap, onMenuItemStateChange, beforeMenuItemClick, domProps } = props;
    const [localMenuData, setLocalMenuData] = useState([]);
    useEffect(() => {
        if (menu && menu.length) {
            const localData = mergeMenuConfig(menu, defaultMenu);
            setLocalMenuData(localData);
        }
        else {
            setLocalMenuData(defaultMenu);
        }
    }, [menu, defaultMenu]);
    const beforeMenuClickRef = useCreateCallbackForEvent(beforeMenuItemClick);
    return useMemo(() => {
        return mail ? (React.createElement(MailMenuRender, { beforeMenuClick: beforeMenuClickRef, data: localMenuData, menuItemStateMap: menuItemStateMap, onMenuItemStateChange: onMenuItemStateChange, mailData: mail, onMenuClick: onMenuClick, domProps: domProps })) : (React.createElement("div", null));
    }, [localMenuData, mail, onMenuItemStateChange, menuItemStateMap]);
};
export default MailMenuBase;
